import React, { useState, useEffect, useRef } from 'react';
import { Slide } from 'react-slideshow-image';
import Slider from 'react-slick';

import LazyLoad from 'react-lazy-load';
import _get from 'lodash/get';
import BannerDetail from './BannerDetail';
import { filterBannerSlots } from '../../../../utils/banner';
import ProductWidgetContainer from '../../homepage/ProductWidgetContainer';
import { Feature, Variant } from '../../../../refresh/organism/ABFeature';
import { GTM_CAPTURE_BANNER_VIEWPORT_CLASS_NAME } from '../../../../modules/ga/gtmConstants';
import { filterJioAdsBanners } from '../../../../utils/jioAdsRelated';

import properties from '../../../../modules/ajio-util/properties';
const imageBaseUrl = properties.getProperty('imageBaseUrl');
const left = `${imageBaseUrl}/static/img/carousel-left.svg`;
const right = `${imageBaseUrl}/static/img/carousel-right.svg`;
const carouselPause = `${imageBaseUrl}/static/img/carousel-pause.svg`;
const carouselPlay = `${imageBaseUrl}/static/img/carousel-play.svg`;



export function CarouselWrpper(Component) {
  return function Carousel(props) {
    const slickElm = useRef(null);

    const [focusInSlide, setFocusInSlide] = useState(false);
    const [focusInPrevNextBtn, setFocusInPrevNextBtn] = useState(false);
    const prevBtnRef = useRef(null);
    const nextBtnRef = useRef(null);
    const slideContainerRef = useRef(null)
    const myCarouselItemsRef = useRef(null)
    const validSlides = useRef([])
    const playPauseBtn = useRef(null)
    const [isPlay, setIsPlay] = useState(true)
    // const statusRef = useRef(null)
    const { carouselTimer, banners } = props.componentDetail;
    const isACarousel = true;


    useEffect(() => {
      const slides = document.querySelectorAll('[data-index="-1"]');
      slides.forEach(slide => {
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('tabindex', '-1');
      });
      // Select buttons with data-role="none" inside #scrollable-product-list-items
      const hiddenButtons = document.querySelectorAll(
        '#scrollable-product-list-items button[data-role="none"]'
      );

      hiddenButtons.forEach(button => {
        button.setAttribute('aria-hidden', 'true');
        button.setAttribute('tabindex', '-1');
      });
    }, []);

    useEffect(() => {
      try {
      const carousel = document.querySelectorAll('#rotatedImageComponent .indicators div');
      const indicators = document.querySelectorAll('#rotatedImageComponent .indicators');
      indicators.forEach(indicator => {
        indicator.setAttribute("aria-hidden", "true");
        indicator.setAttribute("tabindex", "-1");
        const buttons = indicator.querySelectorAll('button');
        buttons.forEach(button => {
          button.setAttribute('aria-hidden', 'true');
          button.setAttribute('tabindex', '-1');
        });
      });
      carousel.length > 1 &&
        carousel.forEach(node => {
          node.style.width = `${Math.floor(
            window.innerWidth / props.componentDetail.banners.length
          )}px`;
        });
      // Custom Code
      if (myCarouselItemsRef.current) {
        const slides = Array.from(
          myCarouselItemsRef.current.querySelectorAll('[data-test="slideweb"]')
        );
        slides.forEach((slide) => {
          slide.setAttribute(
            "aria-hidden",
            slide.classList.contains("active") ? "false" : "true"
          );
        });
        const validSlidesTemp = slides.filter(
          (slide) => !slide.closest("div[data-index='-1']")
        );
        validSlides.current = validSlidesTemp;
      }
      const prevBtn = prevBtnRef.current;
      const nextBtn = nextBtnRef.current;
      const handleKeyDown = (event) => {
        if (event.key === 'Tab') {
          if (event.shiftKey) {
            if(event.target.id==="next-btn"){
              returnFocusToSlide(); // Shift + Tab from Next → Back to Slide
              event.preventDefault();
            }
          } else {
            // Tab
            if(event.target.id==="prev-btn"){
              returnFocusToSlide(); // Tab from Prev → Back to Slide
              event.preventDefault();
          }
        }
        }
      };
      const handleFocusInPrevNextBtn = () => {
        myCarouselItemsRef?.current.setAttribute('aria-live', 'polite');
        setFocusInPrevNextBtn(true);
      }
      const handleFocusOutPrevNextBtn = () => {
        if (isPlay)
          myCarouselItemsRef?.current.setAttribute('aria-live', 'off');
        setFocusInPrevNextBtn(false);
      }
      if (prevBtn) {
        prevBtn.addEventListener("focus", () => handleFocusInPrevNextBtn());
        prevBtn.addEventListener("blur", () => handleFocusOutPrevNextBtn());
      }
      if (nextBtn) {
        nextBtn.addEventListener("focus", () => handleFocusInPrevNextBtn());
        nextBtn.addEventListener("blur", () => handleFocusOutPrevNextBtn());
      }
      myCarouselItemsRef.current?.addEventListener('keydown', handleKeyDown);
      return () => {
        myCarouselItemsRef.current?.removeEventListener('keydown', handleKeyDown);
        if (prevBtn) {
          prevBtn.removeEventListener("focus", () => handleFocusInPrevNextBtn());
          prevBtn.removeEventListener("blur", () => handleFocusOutPrevNextBtn());
        }
        if (nextBtn) {
          nextBtn.removeEventListener("focus", () => handleFocusInPrevNextBtn());
          nextBtn.removeEventListener("blur", () => handleFocusOutPrevNextBtn());
        }
      };  
    } catch (error) {
      console.log(error)   
    }
    }, []);

    useEffect(() => {
      if (focusInSlide) {
        const handleKeyDown = (event) => {
          if (event.key == 'Tab') {
            if (event.shiftKey) {
              // Shift + Tab -> Move focus to prevBtnRef
              event.preventDefault();
              prevBtnRef.current?.focus();
            } else {
              // Tab -> Move focus to nextBtnRef
              event.preventDefault();
              nextBtnRef.current?.focus();
            }
          }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
          document.removeEventListener('keydown', handleKeyDown);
        };
      }
    }, [focusInSlide]);
    const returnFocusToSlide = () => {
      try {
        const slides = Array.from(
          myCarouselItemsRef.current?.querySelectorAll('[data-test="slideweb"]') || []
        );

        const validSlides = slides.filter(slide => {
          const container = slide.closest('[data-index]');
          const index = Number(container?.getAttribute('data-index'));
          return index >= 0 && index < banners.length;
        });

        validSlides.forEach(slide => {
          if (slide.getAttribute('aria-hidden') === 'false') {
            slide.setAttribute('tabindex', '0');
            setTimeout(() => {
              slide.focus();
            }, 100);
          } else {
            slide.setAttribute('tabindex', '-1');
          }
        });
      } catch (error) {
        console.log(error);
      }
    };

    if (carouselTimer && banners.length > 1) {
      const playLabel = 'Start automatic slide show';
      const pauseLabel = 'Stop automatic slide show';
      const handleAutoplay = () => {
         if (focusInSlide) {
          return false;
        }
        return isPlay;
      };

      const settings = {
        arrows: true,
        duration: carouselTimer * 1000,
        transitionDuration: 500,
        // duration: carouselTimer * 50000,
        // transitionDuration:  50000,
        infinite: true,
        indicators: true,
        autoplay: handleAutoplay(),
        pauseOnHover: true,
        prevArrow: (
          <div ref={prevBtnRef} role="button" className='carousel-btns prev-btn remove-round-border' tabIndex={0} type="button" id="prev-btn">
            <img  src={left} alt="Previous Slide" aria-controls={`myCarousel-items${props.rowNumber}`}/>
          </div>
        ),
        nextArrow: (
          <div ref={nextBtnRef} role="button" className='carousel-btns next-btn remove-round-border' tabIndex={0} type="button" id="next-btn">
            <img  src={right} alt="Next Slide" aria-controls={`myCarousel-items${props.rowNumber}`}/>
          </div>
        ),
        onChange: (from, to) => handleSlideChange(from, to),

      };
      const handleSlideChange = (from, to) => {
        try {
          setTimeout(() => {
            const slides = Array.from(
              myCarouselItemsRef.current?.querySelectorAll('[data-test="slideweb"]') || []
            );

            // Filter out only valid slides (no clones)
            const validSlides = slides.filter(slide => {
              const container = slide.closest('[data-index]');
              const index = Number(container?.getAttribute('data-index'));
              return index >= 0 && index < banners.length;
            });

            validSlides.forEach((slide, index) => {
              if (index === to) {
                slide.setAttribute('aria-hidden', 'false');
                slide.setAttribute('tabindex', '0');
                const activeSlide = validSlides[to];
                const img = activeSlide?.querySelector('img');
                const alt = img?.getAttribute('alt') || '';
                slide.setAttribute('aria-label', `Slide ${index + 1} of ${validSlides.length} with graphic ${alt}`);
                const container = slide.closest('[data-index]');
                container?.setAttribute('aria-hidden', 'false');
              } else {
                slide.setAttribute('aria-hidden', 'true');
                slide.setAttribute('tabindex', '-1');
                slide.removeAttribute('aria-label');
                const container = slide.closest('[data-index]');
                container?.setAttribute('aria-hidden', 'true');
              }
            });

            // Live region update for screen reader
            const activeSlide = validSlides[to];
            const img = activeSlide?.querySelector('img');
            const alt = img?.getAttribute('alt') || '';
            announceSlide(`Slide ${to + 1} of ${validSlides.length} ${alt}`);
          }, 200);
        } catch (err) {
          console.error('slide change error', err);
        }
      };

      const announceSlide = (message) => {
        const liveRegion = document.createElement('div');

        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');

        liveRegion.style.position = 'absolute';
        liveRegion.style.left = '-9999px';
        liveRegion.style.width = '1px';
        liveRegion.style.height = '1px';
        liveRegion.style.overflow = 'hidden';

        liveRegion.textContent = message;

        document.body.appendChild(liveRegion);

        setTimeout(() => {
          document.body.removeChild(liveRegion);
        }, 1000);
      };

      const handlePlayPause = () => {
        try {
          if (!isPlay) {
            playPauseBtn.current.setAttribute('aria-label', pauseLabel);
            myCarouselItemsRef.current.setAttribute('aria-live', 'off');
          } else {
              playPauseBtn.current.setAttribute('aria-label', playLabel);
              myCarouselItemsRef.current.setAttribute('aria-live', 'polite');
            }
            setIsPlay(prevValue => !prevValue);
          } catch (error) {
            console.log(error)
          }
        }

      props = {...props,setFocusInSlide,myCarouselItemsRef,isPlay,isACarousel}
      return (
        <div id="rotatedImageComponent">
          <style
            dangerouslySetInnerHTML={{
              __html: [
                '#rotatedImageComponent ul.indicators li button.each-slideshow-indicator.active::before {',
                `animation: backgroundLinera ${carouselTimer}s linear !important`,
                '}'
              ].join('\n')
            }}
          />
          <section
            id={`myCarousel${props.rowNumber}`}
            aria-roledescription="carousel"
            aria-label={props.componentDetail.heading ?? "TESTING "}
            className="carousel"
          >
            <div className="carousel-inner" aria-label="Stop automatic slide show" ref={playPauseBtn} onClick={handlePlayPause} role="button" tabIndex={0}>
              {isPlay ? <img src={carouselPause} className='play-pause-btn-carousel' alt=""/> :<img src={carouselPlay} className='play-pause-btn-carousel' alt=""/>}
            </div>
            <div id={`myCarousel-items${props.rowNumber}`} aria-live="off" ref={myCarouselItemsRef}>
              <Slide {...settings} ref={slideContainerRef} >{Component(props)}</Slide>
              {/* <div ref={statusRef} style={{ position: "absolute", left: "-9999px" }} >
              </div> */}
            </div>
          </section>
        </div>
      );
    }
    const allBannersWidth = banners.reduce(
      (totalWidth, { width }) => totalWidth + parseInt(width),
      0
    );
    if (allBannersWidth > 101 && banners.length > 1) {
      const slickSettings = {
        slidesToShow: 100 / parseFloat(banners[0].width),
        // slidesToShow: 100 / banners[0].width,
        speed: 500,
        dots: false,
        infinite: false,
        draggable: false,
        slidesToScroll: 100 / parseFloat(banners[0].width)
        // variableWidth: true,
        // className: "slider variable-width",
        // lazyLoad: 'ondemand',
        // variableWidth: true

        // className: "slider variable-width",
        // dots: false,
        // infinite: false,
        // centerMode: false,
        // slidesToShow: 100 / banners[0].width,
        // slidesToScroll: 1,
        // variableWidth: true
      };

      const customWidth = Math.floor(100 / banners[0].width);
      const lists = banners.map((bannerDetails, key) => (
        <div key={key} style={{ display: 'inline-block' }}>
          <BannerDetail
            key={key}
            isLuxe={props.isLuxe}
            bannerDetails={bannerDetails}
            customWidth={customWidth}
            index={key}
            rowNumber={props.rowNumber}
          />
        </div>
      ));
      return (
        <div
          className="gallery-com feature-overlap"
          style={{ overflow: 'auto', verticalAlign: 'bottom' }}
        >
          <div className="overlap-gallery" id="scrollable-product-list-items">
            <Slider {...slickSettings} ref={slickElm}>
              {lists}
            </Slider>
          </div>
        </div>
      );
    }

    if (allBannersWidth <= 101 && banners.length > 1) {
      return (
        <div style={{ display: 'flex' }}>
          <Component {...props} />
        </div>
      );
    }
    return <Component {...props} />;
  };
}

export function FitToWidthWrapper(Component) {
  return function fitToWidth(props) {
    const { fitToWidth } = props.componentDetail;
    if (fitToWidth) {
      return (
        <div className="full-width">
          <Component {...props} fitToWidth={fitToWidth} />
        </div>
      );
    }
    return <Component {...props} />;
  };
}

function BannerComponentLayout(Component) {
  return function (props) {
    const { heading, bottomPadding, banners = [], type, bgColor } = props.componentDetail;
    return (
      banners?.length > 0 && (
        <div
          className="component-layout"
          style={{ paddingBottom: bottomPadding, position: 'relative', cursor: 'default' }}
        >
          {!!heading &&
            type !== 'WIDGET' &&
            banners.length &&
            banners[0].bannerType !== 'RECOMMENDED_PRODUCTS' &&
            type !== 'SHOPTHELOOK' && (
              <div
                className="com-heading"
                style={{
                  paddingTop: '5px',
                  paddingBottom: '5px',
                  verticalAlign: 'center',
                  backgroundColor: 'white'
                }}
              >
                <div className="heading">
                  <span>{heading}</span>
                </div>
              </div>
            )}
          {type === 'SHOPTHELOOK' && (
            <div
              className="com-heading"
              style={{
                paddingTop: '50px',
                paddingBottom: '30px',
                textAlign: 'center',
                backgroundColor: bgColor || '#fff',
                fontWeight: 'bold',
                fontSize: '36px'
              }}
            >
              <span>Shop The Look</span>
            </div>
          )}
          <div style={{ overflow: 'hidden' }}>
            <Component {...props} />
          </div>
        </div>
      )
    );
  };
}

const BannersLayout = Component =>
  BannerComponentLayout(FitToWidthWrapper(CarouselWrpper(Component)));

function Banners(props) {
  const {
    componentDetail: { banners = [], type, heading, subHeading, bgColor, platform, componentName },
    type: rowType,
    showModal,
    fitToWidth,
    rowNumber,
    isLuxe,
    setFocusInSlide = () => { },
    myCarouselItemsRef = null,
    isPlay,
    isACarousel
  } = props;
  if (
    type === 'WIDGET' &&
    banners.length &&
    (banners[0].bannerType === 'RECOMMENDED_PRODUCTS' ||
      banners[0].bannerType === 'RECENTLY_VIEWED' ||
      banners[0].bannerType === 'DYNAMIC_WIDGET' ||
      banners[0].bannerType === 'CURATED_WIDGET')
  ) {
    return (
      <ProductWidgetContainer
        fitToWidth={fitToWidth}
        banners={banners[0]}
        componentName={componentName}
        heading={heading}
        subHeading={subHeading}
        bgColor={bgColor}
        rowNumber={rowNumber}
        platform={platform}
      />
    );
  }
  const handleFocusIn = () => {
    setFocusInSlide(true);
    myCarouselItemsRef?.current?.setAttribute('aria-live', 'polite');
  };

  const handleFoucsOut = () => {
    setFocusInSlide(false);
    if (isPlay) {
      myCarouselItemsRef?.current?.setAttribute('aria-live', 'off');
    }
  };
  return banners.map((bannerDetails, key, items) => {
    const isSingleItem = items.length === 1;
    const isSingleHotspot = bannerDetails?.hotspots?.length <= 1;
    const isDecorative = bannerDetails.bannerCategory === "DECORATIVE";

    const roleValue = isACarousel && isSingleHotspot && !isSingleItem ? "link"
      : isSingleItem ? undefined
        : "group";

    const ariaLabelValue = isSingleItem
      ? undefined
      : (isACarousel && isSingleHotspot
        ? `${key + 1} of ${items.length} graphic ${bannerDetails?.altText}`
        : `${key + 1} of ${items.length}`);
    return (
      <div
        role={roleValue}
        // aria-roledescription="slide"
        aria-label={ariaLabelValue}
        aria-hidden={bannerDetails.bannerCategory === "DECORATIVE" ? true : undefined}
        tabIndex={isACarousel && bannerDetails?.hotspots?.length <= 1 ? 0 : undefined}
        onClick={e => {
          const a = e.currentTarget.querySelector('a[href]');
       
          if (a) a.click();
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            const a = e.currentTarget.querySelector('a[href]');
            

            if (a) a.click();
          }
        }}
        onKeyUp={e => {
          if (e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            const a = e.currentTarget.querySelector('a[href]');
            

            if (a) a.click();
          }
        }}
        onFocus={handleFocusIn}
        onBlur={handleFoucsOut}
        data-test="slideweb"
        style={{
          width: `${bannerDetails?.width ? bannerDetails?.width : '100'}%`,
          overflow: 'hidden',
          verticalAlign: 'bottom'
        }}
      >
        <BannerDetail
          key={key}
          index={key}
          heading={heading}
          fitToWidth={fitToWidth}
          bannerDetails={bannerDetails}
          rowType={rowType}
          showModal={showModal}
          allBanners={items}
          isLuxe={isLuxe}
          rowNumber={rowNumber}
          muteTimer={true}
          isACarousel={isACarousel}
        />
      </div>
    );
  }
  );
}
function BannersComponentRenderer({
  slots,
  showModal,
  isLuxe,
  jioAdsLandingBannersFlag,
  landingPagesExperiments,
  jioAdsLandingPagesExperiment
}) {
  const newSlots = filterBannerSlots(slots);
  // const newSlots = filterJioAdsBanners(newShopTheLookSlots, jioAdsLandingBannersFlag, landingPagesExperiments, jioAdsLandingPagesExperiment);
  return (
    <div className="banner-components-runtime">
      {newSlots.map((slot, index) => {
        const CompLayout = BannersLayout(Banners);
        const type = _get(slot, 'component.type');
        return (
          _get(slot, 'component.banners', []) && (
            <LazyLoad
              key={index}
              className={GTM_CAPTURE_BANNER_VIEWPORT_CLASS_NAME}
              offsetVertical={600}
              throttle={100}
              debounce={false}
            >
              <CompLayout
                key={index}
                componentDetail={slot.component}
                type={type}
                showModal={showModal}
                rowNumber={slot.rowNumber}
                isLuxe={isLuxe}
              />
            </LazyLoad>
          )
        );
      })}
    </div>
  );
}

export default BannersComponentRenderer;
